export default "__VITE_ASSET__CKHvnofA__"